import type {
  MeetingDirectMessageThread,
  MeetingMessagesPanelResponse,
  MeetingPanelEventPayload,
} from "services/api/meetingsClient"

export const getMessagesPanelUnreadCount = (response: MeetingMessagesPanelResponse) =>
  (response.threads || []).reduce((total, thread) => total + Math.max(0, thread.unread_count || 0), 0)

export const findThreadForMessageEvent = (
  response: MeetingMessagesPanelResponse,
  event: MeetingPanelEventPayload,
): MeetingDirectMessageThread | null => {
  const threadId = typeof event.thread_id === "string" ? event.thread_id : ""
  const senderIdentityKey = typeof event.sender_identity_key === "string" ? event.sender_identity_key : ""
  return (
    response.threads.find((thread) => thread.id === threadId) ||
    response.threads.find((thread) => thread.recipient.identity_key === senderIdentityKey) ||
    null
  )
}

export const wait = (delayMs: number) => new Promise((resolve) => {
  window.setTimeout(resolve, delayMs)
})
